import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
} from "@mui/material";
import { People, Gavel, Shield, Badge, Business } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "../../../globals/components/Navbar";
import { apiClient } from "../../../globals/utils/api";

const SimpleUserAccountManagement = () => {
  const internalUserId = useSelector((state) => state.auth.role_id);
  const [userFeatures, setUserFeatures] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInternalUser = async () => {
      try {
        const response = await apiClient(
          `/get-internal-user/${internalUserId}`,
          "GET"
        );
        setUserFeatures(response.features);
      } catch (error) {
        console.error("Error fetching internal user:", error);
      }
    };
    if (internalUserId) fetchInternalUser();
  }, [internalUserId]);

  const links = [
    {
      name: "Internal Users",
      path: "/vermost_internal_users",
      feature: "internal_users",
      icon: <People fontSize="large" />,
    },
    {
      name: "Law Firms",
      path: "/vermost_lawfirm_list",
      feature: "law_firms",
      icon: <Gavel fontSize="large" />,
    },
    {
      name: "Professional Guardians",
      path: "/vermost-professional-guardian-list",
      feature: "professional_guardians",
      icon: <Shield fontSize="large" />,
    },
    {
      name: "Legal Service Paralegals",
      path: "/vermost_paralegals_list",
      feature: "paralegals",
      icon: <Badge fontSize="large" />,
    },
    {
      name: "Law Firm Users",
      path: "/vermost_law_firm_users",
      feature: "law_firm_users",
      icon: <Business fontSize="large" />,
    },
  ];

  const filteredLinks = links.filter((link) =>
    userFeatures.includes(link.feature)
  );

  return (
    <>
      <Navbar />
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" fontWeight={800} mb={4} sx={{ color: 'black' }}>
          Account Management
        </Typography>
        <Grid container spacing={3}>
          {filteredLinks.map((link, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 3,
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)',
                  border: '1px solid rgba(37, 99, 235, 0.2)',
                  transition: "all 0.3s ease-in-out",
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  "&:hover": {
                    boxShadow: "0 4px 16px rgba(37, 99, 235, 0.15)",
                    background: 'linear-gradient(135deg, #e9ecef 0%, #dee2e6 50%, #e9ecef 100%)',
                    transform: 'translateY(-2px)',
                    borderColor: 'rgba(37, 99, 235, 0.4)',
                  },
                }}
              >
                <CardActionArea onClick={() => navigate(link.path)}>
                  <CardContent
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      padding: 3,
                      color: "#333333",
                    }}
                  >
                    {React.cloneElement(link.icon, { style: { color: '#2563eb' } })}
                    <Typography variant="h6" fontWeight={500} sx={{ color: '#333333' }}>
                      {link.name}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default SimpleUserAccountManagement;
